var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-box-body dimension"},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('div',{staticClass:"row justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-4 col-xs-4 col-lg-4"},[_vm._v(" Loader ")])]),_c('br'),_c('br'),_c('br')])
}]

export { render, staticRenderFns }